import axios from 'axios';
import RestService from '../../helpers/RestService';
import moment from 'moment';
import {toastr} from 'react-redux-toastr'

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';

export function getRooms() {
  return async (dispatch) => {
    try {
      const {data} = await axios.get('/api/rooms/get-by-owner');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_ROOMS', data: payload})
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      dispatch({type: 'GET_ROOMS', data: []})
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
      
    }
  }
}

export function createRoom(body) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/post', {
        ...body, 
        status: body.status ? 1 : 0,
        active_from: moment(body.active_from).unix(),
        active_to: moment(body.active_to).unix(),
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'NEW_ROOM', data: payload});
        return data;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})      
    }
  }
}
export function deleteRoom(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/delete', { id });

      if(data.errcode == 200) {
        dispatch({type: 'DELETE_ROOM', data: id});
        return data.payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
     
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'})
    }
  }
}


export function updateRoom(body) {
  return async (dispatch) => {
    try {
      
      const {data} = await axios.post('/api/room/patch', {
        ...body, 
        status: body.status ? 1 : 0,
        active_from: moment(body.active_from).unix(),
        active_to: moment(body.active_to).unix(),
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'UPDATE_ROOM', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
      return Promise.reject({message: 'Bag request'}) 
    }
  }
}


export function setRoomItem(data) {
  return async (dispatch) => {
    try {
      dispatch({type: 'SET_ROOM', data})
      return data;
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function getRoomStudents(id) {
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/students', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'GET_ROOM_STUDENTS', data: payload});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export function addRoomStudents(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/add-students', {
        room_id: body.room_id,
        ids: body.students.map(item => item.id),
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'ADD_ROOM_STUDENTS', data: body.students});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export async function sendInvite(body) {
  const {data} = await axios.post('/api/room/send-invite', body);
  if(data.errcode == 200) {
    return true
  } else {
    throw new Error('Not send');
  } 
}

export function deleteRoomStudent(body) {
  console.log("TCL: addRoomStudents -> body", body)
  return async (dispatch) => {
    try {
      const {data} = await axios.post('/api/room/delete-student', body);

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        dispatch({type: 'DELETE_ROOM_STUDENT', data: body.student_id});
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      console.log("TCL: getRooms -> error", error)
    }
  }
}

export async function searchStudents(body) {
  try {
    const {data} = await axios.post('/api/room/search-students', body);

    let payload = [];

    if(data.errcode == 200) {
      payload = data.payload;
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
  } catch (error) {
    console.log("TCL: getRooms -> error", error)
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/RoomsAndStudents/actions.js